<div class="flex flex-col gap-3">
  @if (loading) {
    <div class="flex items-center justify-center gap-2 py-6 text-(--p-text-muted-color)">
      <p-progressSpinner styleClass="!h-5 !w-5" strokeWidth="6" />
      <span>Loading Spaces…</span>
    </div>
  } @else if (loadError) {
    <div class="flex flex-col items-center gap-2 py-6 text-center">
      <span class="text-sm text-red-500">{{ loadError }}</span>
      <p-button label="Retry" size="small" severity="secondary" (onClick)="loadSpaces()" />
    </div>
  } @else {
    <div role="listbox" aria-label="Your Spaces" class="flex flex-col gap-1.5">
      @for (space of spaces; track trackBySpaceId($index, space)) {
        <div
          role="option"
          [attr.aria-selected]="space.id === activeSpaceId"
          class="flex min-h-11 w-full items-center gap-1 rounded-lg border transition-colors"
          [class.border-primary]="space.id === activeSpaceId"
          [class.bg-(--p-highlight-background)]="space.id === activeSpaceId"
          [class.border-surface-200]="space.id !== activeSpaceId"
          [class.dark:border-surface-700]="space.id !== activeSpaceId">
          <button
            type="button"
            class="flex min-h-11 min-w-0 flex-1 items-center gap-3 rounded-lg px-3 py-2 text-left"
            (click)="selectSpace(space)">
            <span
              class="material-symbols-outlined shrink-0 !text-xl"
              [class.text-primary]="space.id === activeSpaceId"
              [class.text-(--p-text-muted-color)]="space.id !== activeSpaceId"
              aria-hidden="true">
              {{ space.id === activeSpaceId ? 'radio_button_checked' : 'radio_button_unchecked' }}
            </span>
            <span class="min-w-0 flex-1">
              <span class="block truncate text-sm font-medium text-(--p-text-color)">{{ space.name }}</span>
              <span class="block text-xs text-(--p-text-muted-color)">
                {{ space.type === 'PRIVATE' ? 'Private' : 'Shared' }} · Owner: {{ space.owner_username }} · {{ space.current_user_role | titlecase }}
              </span>
            </span>
            @if (space.id === activeSpaceId) {
              <span class="shrink-0 rounded-full bg-primary px-2 py-0.5 text-xs font-medium text-primary-contrast">Active</span>
            }
          </button>
          @if (canEditSpace(space)) {
            <p-button
              icon="pi pi-pencil"
              [text]="true"
              [rounded]="true"
              size="small"
              styleClass="!min-h-11 !min-w-11 shrink-0 mr-1"
              [attr.aria-label]="'Edit ' + space.name"
              (onClick)="editSpace($event, space)" />
          }
        </div>
      }
      @if (!spaces.length) {
        <p class="m-0 py-4 text-center text-sm text-(--p-text-muted-color)">No Spaces found.</p>
      }
    </div>

    @if (!showCreateForm) {
      <p-button
        label="New Shared Space…"
        icon="pi pi-plus"
        size="small"
        severity="secondary"
        styleClass="!min-h-11 self-start"
        (onClick)="startCreate()" />
    } @else {
      <div class="flex flex-col gap-2 rounded-lg border border-surface-200 p-3 dark:border-surface-700">
        <label class="text-xs font-medium uppercase tracking-wide text-(--p-text-muted-color)" for="space-picker-name">
          Name
        </label>
        <input
          id="space-picker-name"
          type="text"
          class="p-inputtext p-component min-h-11 w-full"
          [(ngModel)]="newSpaceName"
          placeholder="e.g. Family, Work Team"
          maxlength="100"
          autocomplete="off" />

        <label class="text-xs font-medium uppercase tracking-wide text-(--p-text-muted-color)" for="space-picker-description">
          Description (optional)
        </label>
        <input
          id="space-picker-description"
          type="text"
          class="p-inputtext p-component min-h-11 w-full"
          [(ngModel)]="newSpaceDescription"
          maxlength="250"
          autocomplete="off" />

        @if (createError) {
          <span class="text-sm text-red-500">{{ createError }}</span>
        }

        <div class="mt-1 flex justify-end gap-2">
          <p-button label="Cancel" severity="secondary" styleClass="!min-h-11" [disabled]="creating" (onClick)="cancelCreate()" />
          <p-button
            label="Create"
            styleClass="!min-h-11"
            [loading]="creating"
            [disabled]="!newSpaceName.trim()"
            (onClick)="submitCreate()" />
        </div>
      </div>
    }
  }
</div>
